import {endOfMonth, setDate, startOfMonth} from "date-fns"
import {salesMock10000} from './mockData';
//import {memoize} from "lodash";
import {API_URL} from "../../../../utils/apiURLs";
import MockUtils from "../../../../utils/mock.utils";

const salesMock = salesMock10000();
// const salesMock = [];

const cachedList = (salesMock, date, status) => {
  const splitDate = date.split('-');
  const firstDate = startOfMonth(new Date(splitDate));
  const endDate = endOfMonth(new Date(splitDate));
  return salesMock.filter(it => (
    it.orderDate >= firstDate && it.orderDate <= endDate && it.balanceStatus === status
  ));
};

export default function adapter(mock) {
  mock.onGet(API_URL.BALANCE_SUMMARY).reply(config => {
    const {date, status} = config.params;
    const list = cachedList(salesMock, date, status);
    const calcDate = setDate(new Date(date), 10);
    const temp = {
      totalOrderCount: 0,
      totalSalesCount: 0,
      totalSalesPrice: 0,
      totalCalcPrice: 0,
    };
    const summary = list.reduce((sum, item) => {
      sum.totalSalesCount += item.orderCount;
      sum.totalSalesPrice += item.orderPrice;
      sum.totalCalcPrice += item.calcPrice;
      return sum;
    }, temp);
    summary.totalOrderCount = list.length;
    summary.calcDate = calcDate;
    return [200, {data: summary}];
  });

  mock.onGet(API_URL.BALANCE_SALES_LIST).reply(config => {
    const mockUtils = new MockUtils();
    const {date, filter} = config.params;
    const status = filter.balanceStatus;
    const list = cachedList(salesMock, date, status);
    const findSalesList = mockUtils.baseFilter('salesList');
    const salesList = findSalesList(list, filter);
    return [200, {data: salesList}];
  });

  mock.onGet(API_URL.BALANCE_EXCEL_DOWNLOAD).reply(config => {
    const mockUtils = new MockUtils();
    const {date, queryParams} = JSON.parse(config.data);
    const {sortField, sortOrder} = queryParams;
    const findSalesList = mockUtils.baseFilter('salesList');
    const excelData = findSalesList(salesMock, {date, sortField, sortOrder});
    return [200, {data: excelData}];
  });
}
